import type { PatentValuationEntity } from '../types';

export const PatentValuationService = Symbol.for('PatentValuationService');

export interface PatentValuationService {
    getValuation(patentId: string): Promise<PatentValuationEntity>;
}
